<template>
  <div class="gps-tab">
    <div class="text-center text-gray-400">
      функціонал в розробці
    </div>
  </div>
</template>

<script>
export default {
  name: "GpsTab",
};
</script>
